<template>
  <v-container>
    <v-row>
      <v-col cols="9">
        <QCPhotoFilter :initial-filter="photoFilter" @apply-filters="setPhotoFilters($event)"></QCPhotoFilter>
      </v-col>
    </v-row>
    <v-progress-circular v-if="isLoading" indeterminate></v-progress-circular>

    <PhotoListView :images="photos" :isQc="true"/>

    <v-container v-if="photos.length>0" class=" fixed border--primary">
      <v-btn
          class="mr-2 float-right"
          color="success"
          @click="submitBatch({getNext: true})">Mark Reviewed & get Next Batch
      </v-btn>
      <v-btn
          class="mr-2 float-right"
          color="primary"
          @click="submitBatch({getNext: false})">Mark Reviewed & Close
      </v-btn>
    </v-container>

  </v-container>
</template>

<script>
import PhotoListView from "@/components/PhotoListView";
import QCPhotoFilter from '@/components/filters/QCPhotoFilter'
import axios from "axios";
import {mapActions, mapMutations, mapState} from "vuex";

export default {
  name: 'QualityControl',
  components: {
    QCPhotoFilter,
    PhotoListView,
  },
  data() {
    return {
      categories: [],
      selectedItems: [],
      fromDateVal: '',
      toDateVal: '',
      photoFilter: {
        fromDt: null,
        thruDt: null,
        tags: [],
        projects: [],
        jobs: [],
        taggers: [],
        respIdSearchFreeForm: null,
        onlyNeedsReview: false,
        showQCed: false,
        country: null,
        retailer: null,
        department: null,
      },
      isLoading: false,
    }
  },
  mounted() {
    this.setQCPhotos([])
    this.getPhotos()
  },
  computed: {
    ...mapState({
      photos: state => state.photos.qcPhotos
    })

  },
  methods: {
    ...mapActions(['submitQCAssigned']),
    ...mapMutations(['setMessage', 'setQCPhotos',]),
    getPhotos: function () {
      let self = this
      self.setQCPhotos([])
      self.isLoading = true
      let tagIds = this.photoFilter.tags.map(i => i.id)
      let jobIds = this.photoFilter.jobs.map(i => i.id)
      let projIds = this.photoFilter.projects.map(i => i.id)
      let taggerIds = this.photoFilter.taggers.map(i => i.id)

      let payload = {
        fromDateVal: this.photoFilter.fromDt,
        toDateVal: this.photoFilter.thruDt,
        tags: tagIds,
        jobs: jobIds,
        projects: projIds,
        taggers: taggerIds,
        respIdSearchFreeForm: this.photoFilter.respIdSearchFreeForm,
        onlyNeedsReview: this.photoFilter.onlyNeedsReview,
        showQCed: this.photoFilter.showQCed,
        country: this.photoFilter.country,
        retailer: this.photoFilter.retailer,
        department: this.photoFilter.department,
      };

      return axios.post('/api/photos/quality_control/', payload)
          .then(response => {
            self.isLoading = false
            self.setQCPhotos(response.data)

          })
          .catch(error => {
            self.isLoading = false
            console.log(error)
          })
    },
    setPhotoFilters: function (newFilter) {
      this.photoFilter = newFilter
      this.getPhotos()
    },
    submitBatch(payload) {
      let self = this
      this.submitQCAssigned().then(() => {
        self.setMessage({
          text: 'Photos Marked Reviewed',
          type: 'success',
          alert: true
        })
        self.setQCPhotos([])
        if (payload.getNext) {
          self.getPhotos()
        }
      })
    },
  }
}
</script>

<style>
</style>
